// API Configuration
export const API_CONFIG = {
  // Upload Worker
  UPLOAD_URL:
    import.meta.env.VITE_UPLOAD_URL || 'https://photofeeler-upload.photofeeler.workers.dev',

  // Rating API Worker
  RATE_URL: import.meta.env.VITE_RATE_URL || 'https://photofeeler-api.photofeeler.workers.dev',

  // Supabase Configuration
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
};
